<template>
    <section class="col s12">
        <table class="responsive-table striped">
            <thead>
            <tr>
                <td>Participação</td>
                <td>Pontos</td>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!mostraParticipacoesNaSiac">
                <td>
                    <p class="label-info-nao-encontrada">Não foi localizada participações na SIAC para o coordenador dessa ação</p>
                </td>
                <td>
                    0
                </td>
            </tr>
            <tr v-else
                v-for="(participacao, participacao_i) in mostraParticipacoesNaSiac"
                :key="participacao_i">

                <td>
                    <span>{{ participacao.nome }}</span>
                </td>

                <td>
                    <span>{{ buscaPontuacaoDaParticipacaoNasConfiguracoes(participacao.id) }}</span>
                </td>
            </tr>
            <tr>
                <td></td>
                <td>
                    <p>
                        <strong>Pontuação total:</strong>&nbsp;<span>{{ retornaPontuacaoTotal }}</span>
                    </p>
                </td>
            </tr>
            </tbody>
        </table>

    </section>
</template>

<script>
export default {
    name: "at_participacoes_na_siac",
    inject: ['principal'],
    props: {
        participacoesNaSiac: {
            type: Array,
            default: () => { return [] }
        },

        modoTela: {
            type: String,
            default: null
        },

        configuracaoDasParticipacoes: {
            type: Array,
            default: () => { return [] }
        },

        maximoDePontosParaAsParticipacoes: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            participacoes: this.participacoesNaSiac
        }
    },
    watch: {
        participacoesNaSiac: {
            deep: true,
            handler(newValue){
                this.participacoes = newValue
            }
        },
        participacoes: {
            deep: true,
            handler(newValue){
                this.$emit('update:participacoesNaSiac', newValue)
            }
        },
    },
    computed: {
        mostraParticipacoesNaSiac() {
            if(!this.participacoes || this.participacoes.length <= 0)
                return null

            return _.map(this.participacoes, (partipacao) => {
                return {id: parseInt(partipacao[0]), nome: _.upperCase(partipacao[1])}
            })
        },

        retornaPontuacaoTotal(){
            if(this.principal.analise_tecnica == null)
                return 0

            return this.principal.analise_tecnica.item_participacoes_na_siac_pontuacao
        }
    },
    methods: {
        calculaPontuacaoTotal() {
            if(this.modoTela !== 'visualizacao'){
                this.principal.analise_tecnica.item_participacoes_na_siac_pontuacao = 0;

                _.forEach(this.mostraParticipacoesNaSiac, (participacao) => {
                    const pontuacaoDaParticipacao = this.buscaPontuacaoDaParticipacaoNasConfiguracoes(participacao.id)

                    this.principal.setPontuacaoDeParticipacoesNaSiac(pontuacaoDaParticipacao)
                })
            }
        },

        buscaPontuacaoDaParticipacaoNasConfiguracoes(participacao_id){
            const participacaoConfigurada = _.find(this.configuracaoDasParticipacoes, (part) => { return part.id == participacao_id });

            if(participacaoConfigurada)
                return participacaoConfigurada.pontos;

            return 0;
        }
    },
    mounted() {
        this.calculaPontuacaoTotal()
    }
}
</script>

<style scoped>

</style>
